import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { createLazyComponent, LazyModule } from 'owa-bundling';
import { AccCheckerPluginInterface } from './plugin/AccCheckerPlugin';
import { AccCheckerPaneProps } from './components/AccCheckerPane';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AccCheckerPlugin" */ './lazyIndex')
);

export const LazyAccCheckerPluginClass = createLazyPlugin(
    lazyModule,
    m => m.AccCheckerPlugin,
    'AccChecker',
    null
);

// Types
export { LazyPlugin, AccCheckerPluginInterface, AccCheckerPaneProps };

export const AccCheckerPane = createLazyComponent(lazyModule, m => m.AccCheckerPane);
